import {Component} from "preact";
import styles from './styles.scss';

export default class FormRow extends Component {
    render(props, state, context) {
        return (
            <div class={styles.row}>
                {props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/common/form-row/index.js